import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/SwitchModePowerSupplyEfficiencyHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-29.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .smp { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO (no border-top) ══ */
  .smp-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .smp-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .smp-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .smp-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .smp-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .smp-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .smp-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .smp-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .smp-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .smp-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .smp-bc-item:hover { color: #EB2019; }
  .smp-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .smp-bc-sep img { width: 24px; height: 24px; display: block; }
  .smp-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .smp-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .smp-main-section { padding: 80px 0 120px 0; }
  .smp-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .smp-article { flex: 1; min-width: 0; }

  .smp-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .smp-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .smp-meta-item:last-child { border-right: none; padding-right: 0; }
  .smp-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .smp-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .smp-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .smp-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .smp-article-body p { margin-bottom: 20px; }
  .smp-article-body p:last-child { margin-bottom: 0; }

  .smp-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }

  .smp-h3 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 20px 0 0px 0; line-height: 160%; display: block;
  }

  /* Bullet list */
  .smp-article-body ul {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .smp-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .smp-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .smp-article-body ul li > span { flex: 1; }

  .smp-article-body strong { font-weight: 600; color: #202020; }

  .smp-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .smp-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .smp-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .smp-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .smp-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .smp-nav-btn:hover { color: #EB2019; }
  .smp-nav-btn img { width: 40px; height: 40px; display: block; }

  .smp-share-icons { display: flex; align-items: center; gap: 20px; }
  .smp-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .smp-share-icon:hover { opacity: 0.85; }
  .smp-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .smp-sidebar { flex: 0 0 475px; }
  .smp-sidebar-block { margin-bottom: 60px; }
  .smp-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .smp-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .smp-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .smp-recent-item:hover .smp-recent-title { color: #EB2019; }
  .smp-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .smp-recent-body { flex: 1; min-width: 0; }
  .smp-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .smp-social-icons { display: flex; align-items: center; gap: 30px; }
  .smp-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .smp-social-icon:hover { opacity: 0.8; }
  .smp-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .smp-hero             { height: 350px; }
    .smp-hero-content     { padding: 0 32px; }
    .smp-hero-title       { font-size: 30px; }
    .smp-hero-divider     { width: 100%; max-width: 479px; }
    .smp-breadcrumb       { padding: 24px 0 0 0; }
    .smp-breadcrumb-inner { padding: 0 32px; }
    .smp-inner            { padding: 0 32px; }
    .smp-main-section     { padding: 48px 0 60px 0; }
    .smp-main-row         { flex-direction: column; gap: 48px; }
    .smp-sidebar          { flex: none; width: 100%; }
    .smp-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .smp-hero             { height: 360px; }
    .smp-hero-content     { padding: 0 16px; }
    .smp-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .smp-hero-divider     { width: 100%; }
    .smp-hero-subtitle    { font-size: 14px; }
    .smp-breadcrumb       { padding: 30px 0 0 0; }
    .smp-breadcrumb-inner { padding: 0 16px; }
    .smp-bc-item          { font-size: 14px; gap: 14px; }
    .smp-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .smp-bc-sep img       { width: 22px; height: 22px; }
    .smp-inner            { padding: 0 16px; }
    .smp-main-section     { padding: 30px 0 60px 0; }
    .smp-main-row         { flex-direction: column; gap: 60px; }
    .smp-sidebar          { flex: none; width: 100%; }
    .smp-article-title    { font-size: 20px; margin-bottom: 15px; }
    .smp-article-body     { font-size: 14px; }
    .smp-article-body p   { margin-bottom: 15px; }
    .smp-article-body ul  { margin: 0 0 20px 0; gap: 10px; }
    .smp-article-body ul li { font-size: 14px; }
    .smp-meta-item        { font-size: 14px; }
    .smp-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .smp-h2               { font-size: 16px; margin: 30px 0 0px 0; }
    .smp-h3               { font-size: 14px; margin: 15px 0 0px 0; }
    .smp-nav-btn img      { width: 24px; height: 24px; }
    .smp-nav-btn          { font-size: 14px; }
    .smp-share-icon img   { width: 34px; height: 34px; }
    .smp-sidebar-title    { font-size: 20px; }
  }
`;

const recentPosts = [
  {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function HowSwitchModePowerSupplyImprovesEnergyEfficiency() {
  return (
    <div className="smp">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="smp-hero">
        <img className="smp-hero-bg" src={HeroBgImg} alt="Switch Mode Power Supply Efficiency Hero" />
        <div className="smp-hero-overlay" />
        <div className="smp-hero-content">
          <h1 className="smp-hero-title">
            How Switch Mode Power Supply Improves Energy Efficiency in Devices?
          </h1>
          <hr className="smp-hero-divider" />
          <p className="smp-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="smp-breadcrumb" aria-label="Breadcrumb">
        <div className="smp-breadcrumb-inner">
          <a href="/" className="smp-bc-item">Home</a>
          <span className="smp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="smp-bc-item">News &amp; Updates</a>
          <span className="smp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="smp-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="smp-main-section">
        <div className="smp-inner">
          <div className="smp-main-row">

            {/* ── ARTICLE ── */}
            <article className="smp-article">

              {/* Meta bar */}
              <div className="smp-meta-bar">
                <span className="smp-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="smp-meta-item"><img src={CalendarIcon} alt="date" /> January 24, 2025</span>
                <span className="smp-meta-item"><img src={ClockIconImg} alt="time" /> 7:14 am</span>
                <span className="smp-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="smp-article-title">
                How Switch Mode Power Supply Improves Energy Efficiency in Devices?
              </h1>

              {/* Body */}
              <div className="smp-article-body">

                <p>Looking to power your devices smarter, not harder? That's where <strong>Switch Mode Power Supplies</strong> (SMPS) come in—delivering high efficiency without the bulk or heat of traditional power systems. Think of SMPS as the silent powerhouse behind your tech, keeping everything cool, compact, and consistently running at peak performance. Whether you're building the next breakthrough in medical tech or upgrading industrial automation, SMPS is the modern answer to energy-conscious design. At Ador Powertron, we don't just follow the future of power—we help build it.</p>

                {/* Article image */}
                <img className="smp-article-img" src={ArticleImg} alt="Switch Mode Power Supply" />

                <span className="smp-h2">What is a Switch Mode Power Supply?</span>

                <p><a href="" className="smp-red-link">A Switch Mode Power Supply</a> is an electronic power converter that efficiently transfers power from a source to a load using high-frequency switching techniques. Unlike traditional linear power supplies, SMPS units are compact, lightweight, and offer higher efficiency by minimizing energy loss using pulse conversion.</p>

                <span className="smp-h2">How SMPS Improves Energy Efficiency</span>

                <span className="smp-h3">1. Reduced Power Loss</span>
                <p>SMPS units operate at higher frequencies, which significantly reduces energy loss during voltage conversion. This efficiency translates to lower heat generation and energy consumption.</p>

                <span className="smp-h3">2. Enhanced Thermal Management</span>
                <p>By minimizing power loss, SMPS systems generate less heat, reducing the need for extensive cooling mechanisms. This not only conserves energy but also extends the lifespan of electronic components.</p>

                <span className="smp-h3">3. Compact and Lightweight Design</span>
                <p>The high-frequency operation allows for smaller transformers and components, resulting in a more compact and lightweight power supply unit. This design is ideal for modern electronic devices where space and weight are critical factors.</p>

                <span className="smp-h2">Applications of SMPS in Various Industries</span>

                <p>Switch Mode Power Supplies are integral to numerous industries:</p>

                <ul>
                  <li><span><strong>Consumer Electronics:</strong> Used in devices like computers, televisions, and mobile chargers for efficient power conversion.</span></li>
                  <li><span><strong>Industrial Automation:</strong> Provides reliable power to control systems and machinery.</span></li>
                  <li><span><strong>Telecommunications:</strong> Ensures stable power supply to networking equipment.</span></li>
                  <li><span><strong>Medical Devices:</strong> Offers precise and efficient power for sensitive medical equipment.</span></li>
                </ul>

                <span className="smp-h2">Conclusion</span>

                <p>Switch Mode Power Supplies are essential for enhancing energy efficiency in electronic devices. Their ability to reduce power loss, manage thermal output, and provide reliable performance makes them a preferred choice across various industries. At <a href="/" className="smp-red-link">Ador Powertron</a>, we are committed to delivering cutting-edge SMPS solutions that meet the evolving needs of our clients.</p>

                <span className="smp-h2">Ready to Optimize Your Power Solutions?</span>

                <p>Discover how <a href="/" className="smp-red-link">Ador Powertron's</a> advanced SMPS technology can elevate your device's performance and energy efficiency. <a href="/contact-us" className="smp-red-link">Contact our experts today</a> to find the perfect power solution tailored to your needs.</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="smp-bottom-row">
                <div className="smp-bottom-nav">
                  <a href="/news/emission-control-systems-industrial-challenges-solutions" className="smp-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/smps-vs-traditional-power-supplies" className="smp-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="smp-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/how-switch-mode-power-supply-improves-energy-efficiency-in-devices/" className="smp-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fhow-switch-mode-power-supply-improves-energy-efficiency-in-devices%2F&mode=login" className="smp-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fhow-switch-mode-power-supply-improves-energy-efficiency-in-devices%2F%26title%3DSwitch%2520Mode%2520Power%2520Supply%2520for%2520Efficient%2520Energy%2520%257C%2520AdorPowertron%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fhow-switch-mode-power-supply-improves-energy-efficiency-in-devices%2F" className="smp-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="smp-sidebar">

              {/* Recent Posts */}
              <div className="smp-sidebar-block">
                <p className="smp-sidebar-title">Recent Posts</p>
                <div className="smp-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="smp-recent-item">
                      <img src={post.img} alt={post.title} className="smp-recent-img" />
                      <div className="smp-recent-body">
                        <span className="smp-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="smp-sidebar-block">
                <p className="smp-sidebar-title">Social Media</p>
                <div className="smp-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="smp-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="smp-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}